import { Component, OnInit, ViewContainerRef,ViewChild, TemplateRef, EmbeddedViewRef } from '@angular/core';
import { NgForm} from '@angular/forms';
import { AnnuaireProfessionnelsSanteService } from 'src/app/services/annuaire-professionnels-sante/annuaire-professionnels-sante.service';
import { CorrespondantService } from 'src/app/services/correspondant/correspondant.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { PractitionerSearchParams } from 'src/app/services/mss/mss-service.abstract';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { ReferentielEnum } from 'src/app/utils/enums/referentiel-enum';
import { Correspondant, MssanteEmail } from 'src/app/utils/interfaces/new/correspondant.interface';
import { Header } from 'src/app/utils/interfaces/new/header.interface';
import { Referentiel } from 'src/app/utils/interfaces/new/referentiel.interface';
import { PageEvent } from '@angular/material/paginator';
import { SortEnum } from 'src/app/utils/enums/sort-enum';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { Practitioner } from 'src/app/utils/interfaces/new/Practitioner';
import { AnnuaireComponent } from 'src/app/fragments/modal/annuaire/annuaire.component';
import { MatDialog } from '@angular/material/dialog';

const PROFESSION_OID = '1.2.250.1.71.1.2.7';
const SPECIALITE_OID = '1.2.250.1.71.4.2.5';
type Filtres = {
  perpage: number;
  currentPage: number;
  sortBy?: string;
  sortOrder?: SortEnum;
};

interface GroupedPractitioner extends Omit<Practitioner, 'msSanteAddress'> {
  msSanteAddresses: string[];
}
@Component({
  selector: 'app-correspondants',
  templateUrl: './correspondants.component.html',
  styleUrls: ['./correspondants.component.scss']
})

export class CorrespondantsComponent implements OnInit {
  @ViewChild('formRef') formRef: NgForm;
  @ViewChild('fusionSnackTemplate') fusionSnackTemplate!: TemplateRef<any>;

  public refCategorie = [{id:'Agent Public', libelle:'Agent Public'},{id:'Civil', libelle:'Civil'}, {id:'Fonctionnaire', libelle:'Fonctionnaire'}, {id:'Etudiant', libelle:'Etudiant'}];

  public refSpecialite: Referentiel[];
  public refProfession: Referentiel[];
  currentCorrespondant?: Correspondant;
  isInRppsSearching: boolean;

  public isRppsFromAnn = false;

  public isProfessionFromAnn = false;
  public isSpecialiteFromAnn = false;
  public isAdresseMssFromAnn = false;

  public isNomFromAnn = false;
  public isPrenomFromAnn = false;
  public isCategorieFromAnn = false;

  //TEST NEW INTERFACE

  // Pagination
  public totalPages: number = 1;
  public correspondants: Correspondant[] = [];
  public totalItems = 0;

  public filtre: Filtres = {
    perpage: 20,
    currentPage: 1,
    sortBy: 'nom',
    sortOrder: SortEnum.ASC
  };

  public needle: string = '';
  public idProfession?: string = '';
  public idSpecialite?: string = '';

  // View mode
  public viewMode: 'grid' | 'table' = 'grid';
  public showModal: boolean = false;
  public isEditing: boolean = false;
  public displayedColumns: string[] = ['nom', 'profession', 'adresse', 'telephone', 'mobile', 'autre', 'emails', 'actions'];
  public mssanteEmailsList: MssanteEmail[] = [];
  public actionInProgress: boolean = false;
  public fusionMode = false;
  public connectedDropLists: string[] = [];
  public dropTarget: Correspondant | null = null;
  private searchTimeout: any = null;
  public dragSource: Correspondant | null = null;


  snackRef!: MatSnackBarRef<EmbeddedViewRef<any>>;
  snackProgressValue = 0;
  durationSec = 0;
  private snackInterval: any;

  public fusionChamps: {
    key: string;
    label: string;
    source: any;
    target: any;
    useSource: boolean;
    hide: boolean;
  }[] = [];

  multipleResults = false;
  annuaireResult: GroupedPractitioner[] = [];

  constructor(
    public _ref: ReferentielService,
    private _view: ViewContainerRef,
    private _modal: ModalService,
    public _correspondant: CorrespondantService,
    private _send: HeaderCommunicationService,
    private _annSrv: AnnuaireProfessionnelsSanteService,
    private _snack: SnackbarService,
    private dialog: MatDialog
  ) {
    const head: Header = {
      isBack: true,
      title: "Gestion des correspondants",
      backPage: "utilitaires"
    };
    this._send.announceHeader(head);
  }

  async ngOnInit(): Promise<void> {
    this.refSpecialite = await (await this._ref.findRefListTableHypermed(ReferentielEnum.specialite))
      .map((qualite) => { return { id: qualite.id, libelle: qualite.libelle } });
    this.refProfession = await (await this._ref.findRefListTableHypermed(ReferentielEnum.subjectrole_dmp))
      .map((qualite) => { return { id: qualite.id, libelle: qualite.libelle } }).sort((a, b) => a.libelle.localeCompare(b.libelle));

      // Ajouter les professions à la liste des spécialités personnelles
    this.refSpecialite = [...this.refSpecialite, ...this.refProfession];
    this.refSpecialite.sort((a, b) => a.libelle.localeCompare(b.libelle));

    this.loadCorrespondants();
    // await this.refresh();
  }
  //// NOUVELLE INTERFACE JB

  public getProfessionLabel(id: string | undefined): string {
    return this.refProfession.find(s => s.id === id)?.libelle || '';
  }

  public getSpecialiteLabel(id: string | undefined): string {
    return this.refSpecialite.find(s => s.id === id)?.libelle || '';
  }

  public setViewMode(mode: 'grid' | 'table'): void {
    this.viewMode = mode;
  }

  public openAddModal(): void {
    this.isEditing = false;
    this.currentCorrespondant = {};
    this.showModal = true;
    this.initializeMSSanteEmailsList(this.currentCorrespondant);
  }

  public editCorrespondant(correspondant: Correspondant): void {
    this.isEditing = true;
    this.currentCorrespondant = { ...correspondant };
    this.showModal = true;
    this.initializeMSSanteEmailsList(correspondant);
  }

  public closeModal(): void {
    this.showModal = false;
    this.currentCorrespondant = {};
    this.fusionChamps = [];
  }

  private initializeMSSanteEmailsList(correspondant: Correspondant): void {
    if (correspondant.email2) {
      this.mssanteEmailsList = this.getMSSanteEmails(correspondant.email2);
    } else {
      this.mssanteEmailsList = [];
    }

    // S'assurer qu'il y a au moins un champ vide à l'édition
    const hasEmpty = this.mssanteEmailsList.some(item => item.email.trim() === '');
    if (!hasEmpty) {
      this.mssanteEmailsList.push({ email: '', favori: false });
    }
  }

  private rebuildEmail2FromMSSanteList(): string {
  let hasFavori = false;
    return this.mssanteEmailsList
      .filter(item => item.email.trim() !== '')
      .map(item => {
        const email = item.email.trim();
        if (item.favori && !hasFavori) {
          hasFavori = true;
          return email + '*';
        }
        return email; // favori ignoré s’il y en a déjà un
      })
      .join(',');
  }

  private getMSSanteEmails(rawEmails: string): MssanteEmail[] {
    if (!rawEmails) return [];

    return rawEmails
      .split(',')
      .map(e => e.trim())
      .filter(e => !!e)
      .map(email => {
        const isFavori = email.endsWith('*');
        return {
          email: isFavori ? email.slice(0, -1).trim() : email,
          favori: isFavori
        };
      });
  }

  public addMSSanteEmail(): void {
    this.mssanteEmailsList.push({ email: '', favori: false });
  }

  public removeMSSanteEmail(index: number): void {
    this.mssanteEmailsList.splice(index, 1);

    // S'assurer qu'il reste au moins une entrée vide
    if (this.mssanteEmailsList.length === 0) {
      this.addMSSanteEmail();
    }
  }

  public toggleModalMSSanteFavorite(index: number): void {
    // Une seule favorite possible
    this.mssanteEmailsList.forEach((e, i) => e.favori = i === index);
  }

  public onPageChange(event: PageEvent): void {
    this.filtre.currentPage = event.pageIndex + 1;
    this.loadCorrespondants(); // relance l’appel avec la nouvelle pagination
  }

  public loadCorrespondants(): void {
    // const loadingModal = this._modal.openLoading(this._view);
    this._correspondant.findPaginated(
      this.filtre,
      this.idProfession,
      this.idSpecialite,
      this.needle?.trim()
    ).subscribe({
      next: res => {
        if (res && Array.isArray(res.data)) {
          this.correspondants = res.data;
          this.totalItems = res.total ?? 0;
          this.totalPages = Math.ceil(this.totalItems / this.filtre.perpage);
          this.updateDropLists(); // Mettre à jour les listes de drop

        } else {
          this.correspondants = [];
          this.totalItems = 0;
          this.totalPages = 1;
          this.connectedDropLists = [];
          this.dropTarget = null;
        }
      },
      error: err => {
        console.error('Erreur chargement correspondants :', err);
      },
      complete: () => {
        // this._modal.close(loadingModal);
      }
    });

  }

  public hasActiveFilters(): boolean {
    return !!(this.needle || this.idProfession || this.idSpecialite);
  }

  public clearFilters(): void {
    this.needle = '';
    this.idProfession = '';
    this.idSpecialite = '';
    this.loadCorrespondants();
  }

  public applyFilters(): void {
      if(this.idProfession == '') {}
      if(this.idSpecialite == '') {}
      this.filtre.currentPage = 1; // Reset to first page on filter change
      this.loadCorrespondants();
  }

  public getFavoriteMSSanteEmail(rawEmails: string): string {
    if (!rawEmails) return '';

    const emails = rawEmails
      .split(',')
      .map(e => e.trim());

    // Cherche un favori (terminé par *)
    const favorite = emails.find(email => email.endsWith('*'));

    if (favorite) {
      return favorite.replace(/\*$/, ''); // Retire le * final
    }

    // Sinon, retourne le premier email de la liste
    return emails[0] || '';
  }

  public async deleteCorrespondant(correspondant: any) {
    this.actionInProgress = true; // Indique que la suppression est en cours
    if (this.actionInProgress) {
      const modal = this._modal.openModalConfirmation(this._view, 'Confirmation', 'Voulez-vous vraiment supprimer ce correspondant ?');
      modal.instance.closeEmitter.subscribe(async (res: boolean) => {
        if (res) {
          const loadingModal = this._modal.openLoading(this._view);
          try {
            await this._correspondant.delete(correspondant.id);
            this._modal.close(loadingModal);
            // await this.refresh();
            // Retirer l'élément supprimé de la liste locale
            this.correspondants = this.correspondants.filter(c => c.id !== correspondant.id);
            this.totalItems--; // si tu as un compteur, le décrémenter
            // Recalculer le nombre de pages si besoin
            this.totalPages = Math.ceil(this.totalItems / this.filtre.perpage);
            this.updateDropLists(); // Mettre à jour les listes de drop
          } catch (error) {
            this._modal.close(loadingModal);
            if (error.status === 409) {
              this._snack.openSnackBarError("Ce correspondant est lié à un patient et ne peut pas être supprimé.");
            } else {
              this._snack.openSnackBarError("Erreur lors de la suppression.");
            }
          } finally {
            this._modal.close(loadingModal);
            this.actionInProgress = false; // Réinitialiser l'état d'action
          }
        }
      });
    }

  }

  public async saveCorrespondant(currentCorrespondant: Correspondant){
    if (this.actionInProgress) return;
    this.actionInProgress = true;
    if (!this.formRef?.valid) {
        this._snack.openSnackBarError("Les champs * sont obligatoires.");
        this.actionInProgress = false;
        return;
    }
    const dbCorres = [currentCorrespondant];
    const loader = this._modal.openLoading(this._view);

    try {
      currentCorrespondant.email2 = this.rebuildEmail2FromMSSanteList();

      if (this.isEditing && currentCorrespondant.id) {
        // Mise à jour du correspondant
        await this._correspondant.update(currentCorrespondant.id, dbCorres);
        // Mettre à jour dans la liste locale
        const index = this.correspondants.findIndex(c => c.id === currentCorrespondant.id);
        if (index !== -1) {
          this.correspondants[index] = { ...currentCorrespondant };
        }
      }else  {
        // Création d'un nouveau correspondant
        const createdID = await this._correspondant.create(dbCorres);
        const newCorrespondant = { ...currentCorrespondant, id: createdID };
        this.correspondants.unshift(newCorrespondant);
        this.totalItems++;
        this.updateDropLists(); // Mettre à jour les listes de drop
      }
      this.closeModal(); // Fermer le modal après la sauvegarde
    } catch (e) {
      console.error('Erreur lors de la sauvegarde :', e);
      this._snack.openSnackBarError("Erreur lors de la sauvegarde du correspondant.");
    } finally {
      this.actionInProgress = false; // Réinitialiser l'état d'action
      this._modal.close(loader);
    }
  }

  public onCardDrop(event: CdkDragDrop<any>) {
    const source: Correspondant = event.item.data;
    const target: Correspondant = this.dropTarget;
    this.dropTarget = null; // Réinitialiser le drop target après le drop meme si la fusion n'est pas faite
    if (!target || source.id === target.id) return;
    this.fusionChamps = this.generateFusionChamps(source, target); // Enregistrer la source du drag pour l'utiliser dans la fusion
    this.showModal = true;
    // Exemple de log ou action
    console.log('Fusionner', source, 'avec', target);
  }

  public onDragEntered(target: Correspondant): void {
    this.dropTarget = target;
  }

  public onDragExited(target: Correspondant): void {
    if (this.dropTarget?.id === target.id) {
      this.dropTarget = null;
    }
  }

  private updateDropLists(): void {
    this.connectedDropLists = this.correspondants.map(c => `dropList-${c.id}`);
  }

  public onNeedleChange(): void {
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      const trimmed = this.needle?.trim() || '';
      if (trimmed.length === 0 || trimmed.length > 2) {
        this.filtre.currentPage = 1;
        this.loadCorrespondants();
      }
    }, 500);
  }

  private generateFusionChamps(source: Correspondant, target: Correspondant): any[] {
    const labels: { [key: string]: string } = {
      titre: 'Titre',
      nom: 'Nom',
      prenom: 'Prénom',
      adresse1: 'Adresse 1',
      adresse2: 'Adresse 2',
      adresse3: 'Adresse 3',
      codePostal: 'Code postal',
      ville: 'Ville',
      telephone1: 'Téléphone 1',
      telephone2: 'Téléphone 2',
      portable1: 'Mobile 1',
      portable2: 'Mobile 2',
      telephonePerso: 'Téléphone perso',
      fax: 'Fax',
      email1: 'Email',
      email2: 'Email 2',
      adresseApiCrypt: 'Adresse Apicrypt',
      rpps: 'RPPS',

      // Champs techniques ou non fusionnables
      infos: 'Informations (masqué)',
      id: 'ID (masqué)',
      idProfession: 'ID Profession (masqué)',
      idSpecialite: 'ID Spécialité (masqué)',
      secteur: 'Secteur (masqué)',
      categorie: 'Catégorie (masqué)',
      passwordHprim: 'Mot de passe Hprim (masqué)',
      nomApiCrypt: 'Nom Apicrypt (masqué)',

      isRppsFromAnn: 'RPPS Annuaire (masqué)',
      isProfessionFromAnn: 'Profession Annuaire (masqué)',
      isSpecialiteFromAnn: 'Spécialité Annuaire (masqué)',
      isAdresseMssFromAnn: 'Adresse MSS Annuaire (masqué)',
      isNomFromAnn: 'Nom Annuaire (masqué)',
      isPrenomFromAnn: 'Prénom Annuaire (masqué)',
      isCategorieFromAnn: 'Catégorie Annuaire (masqué)',
    };

    const hiddenKeys = [
      'infos','id', 'idProfession', 'idSpecialite', 'secteur', 'categorie',
      'passwordHprim', 'nomApiCrypt', 'idsource',
      'isRppsFromAnn', 'isProfessionFromAnn', 'isSpecialiteFromAnn',
      'isAdresseMssFromAnn', 'isNomFromAnn', 'isPrenomFromAnn', 'isCategorieFromAnn'
    ];

    return Object.keys(labels)
      .map(key => {
        const sourceVal = source[key as keyof Correspondant] ?? '';
        const targetVal = target[key as keyof Correspondant] ?? '';
        return {
          key,
          label: labels[key],
          source: sourceVal,
          target: targetVal,
          useSource: !!sourceVal && !targetVal,
          hide: hiddenKeys.includes(key)
        };
      });
  }

  get fusionChampsVisibles(): any[] {
    return this.fusionChamps.filter(
      c => !c.hide && c.source && c.source !== c.target
    );
  }

  public lancerSnackFusion(): void {
    this.snackRef = this._snack.openSnackFromTemplate(this.fusionSnackTemplate);

    this.snackProgressValue = 0;
    const step = 100; // ms
    const durationMs = 10000; // Durée totale en ms
    this.durationSec = durationMs/1000;
    const totalSteps = durationMs / step;

    this.snackProgressValue = 0;
    let currentStep = 0;

    this.snackInterval = setInterval(() => {
      currentStep++;
      this.snackProgressValue = Math.round((currentStep / totalSteps) * 100);
      // this.cdr.detectChanges(); // <-- forcer l’update du template
      if (currentStep >= totalSteps) {
        clearInterval(this.snackInterval);
        if (this.snackRef) {
          this.snackRef.dismissWithAction(); // Valide comme si on avait cliqué sur le bouton
        }
      }
    }, step);

    this.snackRef.afterDismissed().subscribe(info => {
      clearInterval(this.snackInterval);
      this.snackProgressValue = 0;
      if (info.dismissedByAction) {
        this.confirmFusion(); // bouton "check" ou timeout
      } else {
        this.cancelFusion(); // bouton "annuler"
      }
    });
  }

  public cancelFusion(): void {
    clearInterval(this.snackInterval);
    this.snackRef.dismiss();
    console.log('Fusion annulée');
  }

  public async confirmFusion(): Promise<void> {
    try {
      const currentCorrespondant = this.getFusionTarget(this.fusionChamps);

      // Récupération de l'id de la source depuis les champs de fusion
      const idsourceChamp = this.fusionChamps.find(champ => champ.key === 'id');
      const idsource = idsourceChamp?.source;

      if (currentCorrespondant.id && idsource) {
        await this._correspondant.merge(currentCorrespondant.id, idsource, currentCorrespondant);
        //suppression dans le front de l'idsource et maj de l'idtarget
        // Mettre à jour dans la liste locale
        const indexTarget = this.correspondants.findIndex(c => c.id === currentCorrespondant.id);
        if (indexTarget !== -1) {
          this.correspondants[indexTarget] = { ...currentCorrespondant };
        }
        const indexSource = this.correspondants.findIndex(c => c.id === idsource);
        if (indexSource !== -1) { //delete ligne !
          this.correspondants = this.correspondants.filter(c => c.id !== idsource);
        }
      }

      this.closeModal();
    } catch (error) {
      this._snack.openSnackBarError(error);
    }
  }

  public getFusionTarget(fusionChamps: any): Correspondant {
    const result = fusionChamps.reduce((acc, champ) => {
      const key = champ.key as keyof Correspondant;

      // Traitement spécial pour email2 (concat avec séparateur évitant doublons)
      if (key === 'email2') {
        const emails = [
          ...(champ.target ? champ.target.split(',') : []),
          ...(champ.useSource && champ.source ? champ.source.split(',') : [])
        ];

        // Nettoyage : suppression des étoiles et des doublons
        const uniques = [...new Set(
          emails
            .map(e => e.trim().replace(/\*$/, '')) // Trim + suppression du * final s'il existe
            .filter(e => !!e)
        )];

        acc[key] = uniques.join(',');
      }

      // Traitement spécial pour infos (concat texte avec saut de ligne)
      else if (key === 'infos') {
        const infosParts = [
          champ.target?.trim() || '',
          champ.source ? `\n- ${champ.source.trim()}` : ''
        ];
        acc[key] = infosParts.join('').trim();
      }

      // Cas normal
      else {
        acc[key] = champ.useSource ? champ.source : champ.target;
      }

      return acc;
    }, {} as Correspondant);

    return result;
  }

  public async findInfoByRpps() {
    if(!this.isInRppsSearching){
      const event = this.currentCorrespondant.rpps;
      if (!event || event === '') {
        return;
      }
      const load = this._modal.openLoading(this._view);
      this.isInRppsSearching = true;
      try {
        //MAJ fiche via RPPS Annuaire
        let mailMss: string[] = [];
        const ldapFilter: PractitionerSearchParams = {
          rpps: event
        };
        const ldapKeys = Object.keys(ldapFilter);
        const atLeastOneValidField = ldapKeys.find(k => ldapFilter[k] !== undefined && ldapFilter[k] !== null && ldapFilter[k] !== '');
        if (atLeastOneValidField) {
          const tmp = await this._annSrv.searchProfessionals(ldapFilter, -1, 0, true);
          if (!tmp || tmp.result.length === 0) {
            this._snack.openSnackBarWarning("Aucun professionnel trouvé dans l'annuaire santé pour ce RPPS.");
            return;
          }
          const grouped = this.groupPractitionersByLieu(tmp.result);
          this.annuaireResult = grouped;

          if (grouped.length === 1) {
            this.handleUniqueResult(this.annuaireResult[0]);
          } else {
            this.multipleResults = true;
          }

        }

      } catch (error) {
        console.error(error);
      } finally {
        this._modal.close(load);
        this.isInRppsSearching = false;
      }
    }
  }

  private groupPractitionersByLieu(practitioners: Practitioner[]): GroupedPractitioner[] {
    const groupedMap = new Map<string, GroupedPractitioner>();

    for (const p of practitioners) {
      const key = [
        p.practitionerName,
        p.firstName,
        p.profession,
        p.zip,
        p.city,
        p.address,
        p.codeProfession,
        p.codeSpecialite,
      ].join('|').toLowerCase().trim();

      if (!groupedMap.has(key)) {
        groupedMap.set(key, {
          ...p,
          msSanteAddresses: [p.msSanteAddress?.trim()].filter(Boolean)
        });
      } else {
        const existing = groupedMap.get(key)!;
        if (p.msSanteAddress && !existing.msSanteAddresses.includes(p.msSanteAddress.trim())) {
          existing.msSanteAddresses.push(p.msSanteAddress.trim());
        }
      }
    }

    return Array.from(groupedMap.values());
  }

  private handleUniqueResult(practitioners: GroupedPractitioner): void {
    // this.prefillFromPractitioner(practitioner); // préremplit le formulaire
    const emailsConcat = practitioners?.msSanteAddresses.join(', ') ?? '';
    if(emailsConcat){
      const newEmails = this.getMSSanteEmails(emailsConcat);
      const existingEmails = this.mssanteEmailsList.map(e => e.email.toLowerCase());

      const emailsToAdd = newEmails.filter(e => !existingEmails.includes(e.email.toLowerCase()));
      this.mssanteEmailsList.push(...emailsToAdd);
      this.currentCorrespondant.isAdresseMssFromAnn = true;
    }

    if (practitioners.address != null && practitioners.address !== '') {
      this.currentCorrespondant.adresse1 = practitioners.address;
    }
    if (practitioners.zip != null && practitioners.zip !== '') {
      this.currentCorrespondant.codePostal = practitioners.zip;
    }
    if (practitioners.city != null && practitioners.city !== '') {
      this.currentCorrespondant.ville = practitioners.city;
    }
    if (practitioners.practitionerName != null && practitioners.practitionerName !== '') {
      this.currentCorrespondant.nom = practitioners.practitionerName;
      this.currentCorrespondant.isNomFromAnn = true;
    }
    if (practitioners.firstName != null && practitioners.firstName !== '') {
      this.currentCorrespondant.prenom = practitioners.firstName;
      this.currentCorrespondant.isPrenomFromAnn = true;
    }
    if (practitioners.codeProfession != null && practitioners.codeProfession !== '') {
      this.currentCorrespondant.idProfession = practitioners.codeProfession+'++'+PROFESSION_OID;
      this.currentCorrespondant.isProfessionFromAnn = true;
    }
    if (practitioners.codeSpecialite != null && practitioners.codeSpecialite !== '') {
      this.currentCorrespondant.idSpecialite = practitioners.codeSpecialite+'++'+SPECIALITE_OID;
      this.currentCorrespondant.isSpecialiteFromAnn = true;
    }
    this.currentCorrespondant.isRppsFromAnn = true;
  }

  public onSelectLdapGroupedResult(p: GroupedPractitioner): void {
    this.multipleResults = false;
    this.handleUniqueResult(p); // fait le préfill + regroupe tous les mails
  }

  public openAnnuaireModal(): void {
    const dialogRef = this.dialog.open(AnnuaireComponent, {
      width: 'auto',
      height: 'auto',
      disableClose: true,
      data: {
        from: 'correspondant'
      }
    });

    // Tu peux aussi écouter la fermeture si un jour tu veux l'utiliser
    const sub = dialogRef.afterClosed().subscribe(() => {
      // ...
      sub.unsubscribe(); // facultatif ici car le stream complete après fermeture
    });
  }
}
